export default __webpack_public_path__ + "static/media/wireframeDashboard.7b5942d0.webp";